import { render, staticRenderFns } from "./RequirementDocumentTypeAddNew.vue?vue&type=template&id=3efdbe78"
import script from "./RequirementDocumentTypeAddNew.vue?vue&type=script&lang=js"
export * from "./RequirementDocumentTypeAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports